import PopupMenu from "ui/elements/popup-menu/PopupMenu";
import {i18n} from "ui/i18n";

export default class CanvasContextMenu {
	/**
	 * @param {Canvas} canvas
	 * @param {number} x
	 * @param {number} y
	 */
	constructor(canvas, x, y) {
		/**
		 * @type {Canvas}
		 * @private
		 */
		this._canvas = canvas;

		this._menu = new PopupMenu({
			position: {x, y},
			buttons: [
				{
					caption: i18n('buttons.download-image'),
					icon: '/images/icons.svg#icon-svg-download',
					role: 'download-image'
				}
			]
		});

		this._menu.getResult().then(role => {
			if (role === 'download-image') {
				this._downloadImage();
			}
		});
	}

	_downloadImage() {
		const link = document.createElement('a');
		link.href = this._canvas.getCurrentFrameImageData();
		link.download = 'frame_' + this._canvas.getCurrentFrame() + '.png';
		link.click();
	}
}
